// extracted by mini-css-extract-plugin
module.exports = {"LoginWithApp":"styles_LoginWithApp___wtcw","LoginWithApp-btn":"styles_LoginWithApp-btn__QfiPw"};